module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_9.bcf45ea1.png";